import { useState } from 'react';
import { useProductPageContext } from '@/components/v2/product/hooks/useProductPageContext';
import Origin from './Origin';
import { getComplianceInfo } from './constants';
import settings from '@/settings';
import i18n from '@/settings/i18n';
import ComplianceModal from './compliance/ComplianceModal';

const t = i18n.init('product');

// Seller origin and compliance link. Delivery dates live in the read-only
// strip under Add to Cart, and express shipping is chosen in the cart.
const SellerInfo = () => {
  const { selectedSkuDetails } = useProductPageContext();
  const [showComplianceModal, setShowComplianceModal] = useState(false);

  const complianceInfo = getComplianceInfo(
    settings.store,
    selectedSkuDetails.brandName,
  );

  return (
    <div className="mb-2 px-5 lg:px-0" id="seller-info">
      <div className="-mt-2 flex flex-wrap items-center justify-between gap-x-4 gap-y-1">
        <Origin />
        {complianceInfo && (
          <button
            className="shrink-0 text-xs leading-none text-gray-700/60 underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
            onClick={() => setShowComplianceModal(true)}
          >
            {t`Compliance Information`}
          </button>
        )}
      </div>
      {complianceInfo && (
        <ComplianceModal
          setShowModal={setShowComplianceModal}
          showModal={showComplianceModal}
          info={complianceInfo}
        />
      )}
    </div>
  );
};

export default SellerInfo;
